import React, { useState } from 'react';
import { useAuth } from '../context/AuthContext';
import { useNavigate, useLocation } from 'react-router-dom';
import LoadingSpinner from '../components/LoadingSpinner';

// Stili CSS in linea
const styles = {
    container: { display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '100vh', background: 'var(--background-light)' },
    card: { padding: '2.5rem 2rem', background: 'var(--card-background)', borderRadius: '8px', boxShadow: 'var(--shadow-md)', width: '100%', maxWidth: '400px', textAlign: 'center' },
    logo: { height: '60px', width: 'auto', marginBottom: '1.5rem' },
    form: { display: 'flex', flexDirection: 'column', gap: '1rem' },
    input: { /* Stile già in index.css */ },
    button: { /* Stile .button e .button-primary già in index.css */ },
    error: { color: 'red', textAlign: 'center', marginTop: '1rem' }
};

const LoginPage = () => {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const [isLoading, setIsLoading] = useState(false); // Stato di loading per il login
    const { login } = useAuth();
    const navigate = useNavigate();
    const location = useLocation();

    const from = location.state?.from?.pathname || '/';

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');
        setIsLoading(true); // Avvia il loading

        const success = await login(email, password);

        setIsLoading(false); // Ferma il loading

        if (success) {
            navigate(from, { replace: true });
        } else {
            setError('Email o password errati.');
        }
    };

    return (
        <div style={styles.container}>
            {/* Mostra lo spinner in overlay se isLoading è true */}
            {isLoading && <LoadingSpinner fullPage={true} />}

            <div style={styles.card}>
                <img src="/mapp_logo.png" alt="MAPP Logo" style={styles.logo} />

                <form style={styles.form} onSubmit={handleSubmit}>
                    <input
                        type="email"
                        placeholder="Email"
                        style={styles.input}
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        required
                        disabled={isLoading}
                    />
                    <input
                        type="password"
                        placeholder="Password"
                        style={styles.input}
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        required
                        disabled={isLoading}
                    />
                    <button type="submit" className="button button-primary" style={{ marginTop: '0.5rem' }} disabled={isLoading}>
                        Accedi
                    </button>
                </form>
                {error && <p style={styles.error}>{error}</p>}
            </div>
        </div>
    );
};

export default LoginPage;